/**
 * Vehicle electric battery type values
 */
export enum VehicleElectricBatteryTypeEnum {
	IRON_PHOSPHATE = 'iron_phosphate',
	LI_ION = 'liion',
	LI_POLY = 'lipoly',
	LEAD_ACID = 'lead_acid',
	LITHIUM_ION = 'lithium_ion',
	NICKEL_METAL_HYDRIDE = 'nickel_metal_hydride',
	NICKLE_COBALT_ALUMINUM = 'nickle_cobalt_aluminum',
	NICKLE_COBALT_MANGANESE = 'nickle_cobalt_manganese',
	SILICON = 'silicon',
}
